module.exports = __webpack_public_path__ + "img/administracion.f9ec030b.png";